import { localhost } from "./server_url";
const apiURL = "/api";

export const endpoint = `${localhost}${apiURL}`;
// export const endpointDuc = `${localhostDuc}${apiURL}`;

export const loginURL = `${endpoint}/token/`;
// export const loginURL = `${endpoint}/login_general/`;
export const logoutURL = `${endpoint}/logout/`;
export const changePass = `${endpoint}/change-pass/`;
export const resetPassUrl = `${endpoint}/reset-pass/`;

export const token_refresh_URL = `${endpoint}/token/refresh/`;
export const registerURL = `${endpoint}/rest-auth/registration/`;
export const userIDURL = `${endpoint}/user-permission/`;
// export const userURL = id => `${endpoint}/user/${id}`; // Lỗi
export const manageUserURL = (id) => `${endpoint}/user-manager/${id}`;
export const userURL = (id) => `${endpoint}/detail-user/${id}`;
export const createUserURL = `${endpoint}/user-manager`;
export const userListUser = `${endpoint}/list-user/`;
export const checkProjectURL = `${endpoint}/check-project/`;
export const checkUserProjectURL = `${endpoint}/check-user-project/`;

export const listprojectURL = `${endpoint}/list-project`;
export const forgotPasswordURL = `${endpoint}/forgotPassword`;
export const renewPassURL = (tok) => `${endpoint}/renewpass/${tok}`;
export const updateAvatarURL = `${endpoint}/update-avatar/`;

export const CONTRACT_CODE = "BO-CONTRACT";
export const CONTRACT_CODE_CP = "BO-CONTRACT-CP";
